module.exports = __webpack_public_path__ + "img/right.df52ff95.png";